import React, { useMemo } from "react";
import { useLabelsContext } from "../../context/LabelsContext";
import { REGISTRATION_STEPS } from "../../models/registration-steps";
import { useAuthContext } from "../../context/AuthContext";
import { isMobile } from "react-device-detect";
type RegistrationFormHeaderProps = {
	step: "registration" | "payment" | "success";
};
export const RegistrationFormHeader: React.FC<RegistrationFormHeaderProps> = ({
	step,
}: RegistrationFormHeaderProps) => {
	const { labels } = useLabelsContext();
	const { interestedUser } = useAuthContext();
	const headerText = useMemo((): string => {
		if (step === REGISTRATION_STEPS.PAYMENT) {
			return labels?.["ClubRegistrationPaymentFormTitle"] || "";
		}
		if (interestedUser?.MissingRequiredField) {
			return labels?.["CompleteRegistrationFormTitle"] || "";
		}
		return labels?.["ClubRegistrationFormTitle"] || "";
	}, [labels, step, interestedUser?.MissingRequiredField]);

	return (
		<div className={`form-header ${isMobile ? "text-center" : ""}`}>
			<span
				className='form-header-title'
				dangerouslySetInnerHTML={{ __html: headerText }}
			/>
		</div>
	);
};
